import { z } from 'zod/v4';

export const webProductSchema = z.object({
  productId: z.number().min(1),
  name: z.string().min(1),
});

export type WebProduct = z.infer<typeof webProductSchema>;
